import Link from "next/link"

type EmptyStateProps = {
  icon?: string
  title: string
  description: string
  actionLabel?: string
  actionHref?: string
}

export function EmptyState({
  icon = "🐈",
  title,
  description,
  actionLabel,
  actionHref,
}: EmptyStateProps) {
  return (
    <div className="rounded-[1.75rem] border border-dashed border-neutral-300 bg-white p-8 text-center shadow-sm">
      <div className="text-4xl">{icon}</div>

      <h2 className="mt-4 text-xl font-semibold text-neutral-950">
        {title}
      </h2>

      <p className="mx-auto mt-3 max-w-2xl text-sm leading-7 text-neutral-600">
        {description}
      </p>

      {actionLabel && actionHref ? (
        <div className="mt-6">
          <Link href={actionHref} className="button-secondary">
            {actionLabel}
          </Link>
        </div>
      ) : null}
    </div>
  )
}